import services, { logError } from '../services';
import { showAlert } from '../../components/UI';


export function sendAPIRequest(query, variables, binaries){
  const graphQLMethod = parseGraphQLMethodFromQuery(query);

  return services.graphQLClient.query(query, variables, binaries)
    .then(data => data[graphQLMethod])
    .catch(rawError => {
      const defaultErrorMessage = `${graphQLMethod}: ${getErrorMessageFromResponse(rawError)}`;
      const errorType = rawError?.errors?.[0]?.reason || null;
      const additionalErrorData = {
        defaultErrorMessage,
        errorType,
        rawError,
        query,
        variables,
        graphQLMethod,
      };

      let errorMessage = defaultErrorMessage;
      let alert = true;

      const overrideErrorNotification = (params) => {
        if ('errorMessage' in params) {
          errorMessage = params.errorMessage;
        }
        if ('alert' in params) {
          alert = params.alert;
        }
      };

      setTimeout(() => {
        logError(errorMessage, additionalErrorData);
        if (alert) {
          showAlert({ text: errorMessage, dontAutoHide: true, type: 'error' });
        }
      }, 500);

      throw {
        errorMessage,
        overrideErrorNotification,
        ...additionalErrorData,
      };
    });
}


export function simplifyGraphQLJSON(graphQLJSON){
  if (!graphQLJSON?.edges?.length) {
    return [];
  }
  return graphQLJSON.edges.map(data => ({
    ...data.node,
    cursor: data.cursor,
  }));
}


export function getErrorMessageFromResponse(response){
  let errorMessage = 'Unknown error';
  if (response) {
    if (response.errors && response.errors.length) {
      errorMessage = response.errors.map(error => {
        let message = '\n  - ' + error.message;
        if (error.path && error.path.length) {
          message += ' in ' + error.path.join(', ')
        }
        return message;
      }).join('');
    }
    else if (response.message) {
      errorMessage = response.message;
    }
  }
  return errorMessage;
}


/**
 * When used like this:
 *  @example gql`some string`
 * it simply returns its argument i.e. "some string"
 *
 * It's only designed to make WebStorm Plugin "JS GraphQL" highlight strings as graphql queries
 */
export function gql(queryParts, ...variables){
  let str = '';
  for (let i = 0; i < queryParts.length; i ++) {
    str += queryParts[i] + (variables[i] || '');
  }
  return str;
}


export function insertGraphQLFragments(query, fragments = {}){
  return query + Object.values(fragments).join('\n');
}


export function parseGraphQLMethodFromQuery(query){
  try {
    return query.trim()
      .replace(/(\([^\)]*\))/ig, '')
      .replace(/([a-z]+)?\s*/i, '')
      .replace(/^\{\s*|\s*\}$/ig, '')
      .split(/\s*\{/)[0];
  }
  catch (e) {
    return '';
  }
}
